module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img-2.babe6da8.webp";